module.exports = __webpack_public_path__ + "img/08.64185e55.png";